{
  "moreActions": "Mais ações"
}
